import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { isAfter, parse } from '@sequencehq/utils/dates'

export const useScheduleHasFuturePhases = (props: {
  billingScheduleId: string
}) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      const lastPhaseStartDate = data.billingSchedule.phases
        .map(p => parse(p.startDate, 'yyyy-MM-dd', new Date()))
        .findLast(psd => {
          return isAfter(psd, new Date())
        })

      return {
        hasFuturePhases: Boolean(lastPhaseStartDate),
        lastPhaseStartDate
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    hasFuturePhases: billingScheduleAggregateQuery.data?.hasFuturePhases,
    lastPhaseStartDate: billingScheduleAggregateQuery.data?.lastPhaseStartDate
  }
}
